import {z} from 'zod'
import {zx} from 'shared/type'

/** this can be things we add to the user's metadata, or by default from providers like google. We are only defining the things the app uses */
export const zUserMd = z.object({
  avatar_url: z.string().optional(),
  name: z.string().optional()
  // email_verified: z.boolean().optional()
  // tour: zTourSettings.optional() // we used to use this, but the local version was cached and the updates were throttled
})
export type UserMd = z.infer<typeof zUserMd>

export const zPortalQuery = z.object({
  workspace: z.string().optional(),
  invite: z.string().optional(), // open invite link
  emailInvite: z.string().optional(), // invite id specifically sent to that email
  anon: zx.nullish.bool,
  email: z.string().optional(),
  noPrompt: zx.nullish.bool
})

export const authActions = ['recovery', 'magiclink', 'post-anon-signup'] as const
export type AuthAction = (typeof authActions)[number]

export const zAuthActionQuery = z.object({
  authAction: zx.enumSafe(z.enum(authActions)),
  authDescription: z
    .string()
    .optional()
    .transform(val => val?.replace(/\+/g, ' ')),
  error: z.string().optional(),
  error_code: z.string().optional(),
  error_description: z.string().optional(),
  auth_replacement_token: z.string().optional(),
  auth_old_user_id: z.string().optional()
})
export type AuthActionQuery = z.infer<typeof zAuthActionQuery>

export type PortalStatus = 'unknown' | 'un-authenticated' | 'authenticated' | 'error'

// export const portalUserAtom = atom<PortalUser | null | undefined>(undefined)
// export const seshWorkspaceAtom = atom<string | undefined>(undefined)
